module.exports = __webpack_public_path__ + "img/viewreports.b381544a.svg";